const firebaseConfig = {
  apiKey: "AIzaSyBtAR4_2eAh7XZWGsQdXbM52RVNcZ-6OBE",
  authDomain: "roam-f058e.firebaseapp.com",
  projectId: "roam-f058e",
  storageBucket: "roam-f058e.appspot.com",
  messagingSenderId: "150246974305",
  appId: "1:150246974305:web:2de72efe9c9aaafc199b20"
};
export default firebaseConfig;  